import { useEffect, useState } from 'react';
import { IonModal, IonButton, IonIcon, IonText, useIonToast, useIonPicker } from '@ionic/react';
import { add, addCircleOutline, remove } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
// import { Storage } from '@capacitor/storage';
import './HotelPassenger.css';

interface Props {
    hotelPassengerParentCallback: Function,
    itemValue: any
}
const childRanges = [
    {
        name: 'childRanges',
        options: [
            { value: 1, text: 'تا 1 سال' },
            { value: 2, text: '1 تا 2 سال' },
            { value: 3, text: '2 تا 3 سال' },
            { value: 4, text: '3 تا 4 سال' },
            { value: 5, text: '4 تا 5 سال' },
            { value: 6, text: '5 تا 6 سال' },
            { value: 7, text: '6 تا 7 سال' },
            { value: 8, text: '7 تا 8 سال' },
            { value: 9, text: '8 تا 9 سال' },
            { value: 10, text: '9 تا 10 سال' },
            { value: 11, text: '10 تا 11 سال' },
            { value: 12, text: '11 تا 12 سال' }
        ]
    }
];
const HotelPassenger = (props: Props) => {
    const [toastPresent] = useIonToast();
    const [pickerPresent] = useIonPicker();
    const [state, setState] = useState({
        showHotelPassengerModal: false,
        showChildAgesPicker: false,
        rooms: [
            {
                adults: 2,
                childs: 0,
                childsAges: [] as any,
            }
        ],
        counts: {
            rooms: 1,
            adults: 2,
            childs: 0
        }
    });
    const showToast = (options: any) => {
        toastPresent({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    }
    const titleSwitch = (index: number) => {
        let title = "";
        switch (index) {
            case 0:
                title = "اتاق 1";
                break;
            case 1:
                title = "اتاق 2";
                break;
            case 2:
                title = "اتاق 3";
                break;
            case 3:
                title = "اتاق 4";
                break;
            case 4:
                title = "اتاق 5";
                break;
        }
        return title;
    }
    const addRoom = () => {
        if (state.rooms.length < 5) {
            setState({
                ...state, rooms: [...state.rooms, {
                    adults: 2,
                    childs: 0,
                    childsAges: []
                }],
                counts: {
                    ...state.counts,
                    rooms: state.counts.rooms + 1,
                    adults: state.counts.adults + 1
                }
            });
        }
    }
    const removeRoom = (index: number) => {
        let countsRooms = state.counts.rooms - 1;
        let countsAdults = state.counts.adults - state.rooms[index].adults;
        let countsChilds = state.counts.childs - state.rooms[index].childs;
        state.rooms.splice(index, 1);
        setState({
            ...state,
            rooms: state.rooms,
            counts: {
                rooms: countsRooms,
                adults: countsAdults,
                childs: countsChilds
            }
        });
    }
    const agesUpdate = (index: number, childsAgesIndex: number, value: any) => {
        if (value) {
            let roomsCopyState = state.rooms;
            roomsCopyState[index].childsAges = state.rooms[index].childsAges;
            roomsCopyState[index].childsAges[childsAgesIndex] = value;
            setState({
                ...state,
                rooms: roomsCopyState
            });
        }
    }
    const updatePassenger = (action: string, type: string, index: number) => {
        let rooms = state.rooms;
        if (action === 'plus') {
            if (state.counts.adults + state.counts.childs >= Constants.hotelMaxPassengers) {
                showToast({ message: 'حداکثر تعداد مسافران : ' + (Constants.hotelMaxPassengers), color: 'danger' });
                return;
            }
            if (type === 'adults') {
                rooms[index].adults++;
            }
            if (type === 'childs') {
                rooms[index].childs++;
            }
        } else {
            if (type === 'adults') {
                if (rooms[index].adults === 1) {
                    rooms[index].adults = 1;
                } else {
                    rooms[index].adults--;
                }
            }
            if (type === 'childs') {
                if (rooms[index].childs === 0) {
                    rooms[index].childs = 0;
                    rooms[index].childsAges = [];
                } else {
                    rooms[index].childs--;
                    rooms[index].childsAges.splice(rooms[index].childs - 1, 1);
                }
            }
        }
        if (rooms[index].adults >= 1 && rooms[index].childs >= 0) {
            setState({ ...state, rooms: rooms });
        }
        let passsengersChilds = 0;
        let passsengersAdults = 0;
        let passsengersRooms = 0;
        state.rooms.forEach((value) => {
            passsengersRooms++;
            let roomAdults = value.adults;
            let roomChilds = value.childs;
            passsengersAdults = passsengersAdults + roomAdults;
            passsengersChilds = passsengersChilds + roomChilds;
        });
        setState({ ...state, counts: { rooms: passsengersRooms, adults: passsengersAdults, childs: passsengersChilds } })
    }
    const onCloseModal = () => {
        setState({ ...state, showHotelPassengerModal: false });
        props.hotelPassengerParentCallback(state.rooms);
    }
    const showChildAge = (value: number) => {
        let result = childRanges[0].options.filter((obj: any) => {
            return obj.value === value
        })
        return result[0].text;
    }
    useEffect(() => {
        let adultCounts = 0;
        let childCounts = 0;
        props.itemValue.forEach((item: any) => {
            adultCounts = adultCounts + item.adults;
            childCounts = childCounts + item.childs;
        })
        setState({
            ...state,
            rooms: props.itemValue,
            counts: { rooms: props.itemValue.length, adults: adultCounts, childs: childCounts }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.itemValue])
    return (
        <div>
            <IonModal isOpen={state.showHotelPassengerModal} onDidDismiss={onCloseModal} swipeToClose={false} mode="md" cssClass="hotel-passenger-modal" backdropDismiss>
                <div className="hotel-passenger-modal-container">
                    {state.rooms.map((_, index) =>
                        <div className="hotel-passenger-modal-items" key={"index" + index}>
                            {state.rooms.length === index + 1 ? (
                                <span className="hotel-passenger-modal-item-remove-btn" onClick={() => removeRoom(index)} style={{ display: index < 1 ? 'none' : '' }}>
                                    حذف
                                </span>
                            ) : (
                                null
                            )}
                            <h6>
                                {titleSwitch(index)}
                            </h6>
                            <div className="hotel-passenger-modal-item">
                                <IonIcon icon={add} className="hotel-passenger-modal-icon-add" onClick={() => updatePassenger('plus', 'adults', index)} />
                                <div>
                                    بزرگسال
                                    <small>(12 سال به بالا)</small>
                                    <span>{state.rooms[index].adults}</span>
                                </div>
                                <IonIcon
                                    icon={remove}
                                    className={state.rooms[index].adults === 1 ? "hotel-passenger-modal-icon-remove disabled" : "hotel-passenger-modal-icon-remove"}
                                    onClick={() => updatePassenger('minus', 'adults', index)}
                                />
                            </div>
                            <div className="hotel-passenger-modal-item">
                                <IonIcon icon={add} className="hotel-passenger-modal-icon-add" onClick={() => updatePassenger('plus', 'childs', index)} />
                                <div>
                                    کودک
                                    <small>(0 تا 12 سال)</small>
                                    <span>{state.rooms[index].childs}</span>
                                </div>
                                <IonIcon
                                    icon={remove}
                                    className={state.rooms[index].childs === 0 ? "hotel-passenger-modal-icon-remove disabled" : "hotel-passenger-modal-icon-remove"}
                                    onClick={() => updatePassenger('minus', 'childs', index)}
                                />
                            </div>
                            <div className="child-age-btns">
                                {state.rooms[index].childs > 0 &&
                                    [...Array(state.rooms[index].childs)].map((_, childsAgesIndex) =>
                                        <IonButton
                                            key={"index" + childsAgesIndex}
                                            color="primary"
                                            fill="outline"
                                            className="child-age-btn"
                                            onClick={() =>
                                                pickerPresent({
                                                    cssClass: 'hotel-passenger-picker',
                                                    buttons: [
                                                        {
                                                            text: 'تایید',
                                                            handler: (selected) => {
                                                                agesUpdate(index, childsAgesIndex, selected.childRanges.value)
                                                            },
                                                        },
                                                    ],
                                                    columns: [
                                                        {
                                                            name: 'childRanges',
                                                            options: [
                                                                { value: 1, text: 'تا 1 سال' },
                                                                { value: 2, text: '1 تا 2 سال' },
                                                                { value: 3, text: '2 تا 3 سال' },
                                                                { value: 4, text: '3 تا 4 سال' },
                                                                { value: 5, text: '4 تا 5 سال' },
                                                                { value: 6, text: '5 تا 6 سال' },
                                                                { value: 7, text: '6 تا 7 سال' },
                                                                { value: 8, text: '7 تا 8 سال' },
                                                                { value: 9, text: '8 تا 9 سال' },
                                                                { value: 10, text: '9 تا 10 سال' },
                                                                { value: 11, text: '10 تا 11 سال' },
                                                                { value: 12, text: '11 تا 12 سال' }
                                                            ]
                                                        }
                                                    ],
                                                })
                                            }
                                        >
                                            {state.rooms[index].childsAges[childsAgesIndex] ?
                                                showChildAge(state.rooms[index].childsAges[childsAgesIndex])
                                                :
                                                'سن کودک ' + (childsAgesIndex + 1)
                                            }
                                        </IonButton>
                                    )
                                }
                            </div>
                        </div>
                    )}
                </div>
                <div className="hotel-passenger-modal-btns">
                    <IonButton color="primary" className={state.rooms.length < 5 ? '' : 'display-none'} onClick={addRoom} disabled={state.counts.adults + state.counts.childs >= Constants.hotelMaxPassengers}>
                        <IonIcon icon={addCircleOutline} />
                        افزودن اتاق
                    </IonButton>
                    <IonButton color="warning" onClick={onCloseModal} className="hotel-passenger-modal-close-btn">تایید</IonButton>
                </div>
            </IonModal>
            <IonText onClick={() => setState({ ...state, showHotelPassengerModal: true })}>
                {state.counts.adults + ' بزرگسال , ' + state.counts.childs + ' کودک , ' + state.counts.rooms + ' اتاق'}
            </IonText>
        </div>
    );
};
export default HotelPassenger;